export const AGREEMENT_SIGNER_ROLE = 'AgreementSigner';

export type SigningMode = 'AgtSignSequential' | 'AgtSignParallel';
export type RecipientInfoStatus = 'KNOWN' | 'UNKNOWN';

export interface SigningOrderParty {
  _internalId?: string;
  partyId?: string;
  partyName?: string;
  emailAddress?: string;
  sequenceNum?: number;
  signingOrder?: number;
  roleTypeId?: string;
  party?: any;
  taxCode?: string;
  contactNumber?: string;
  representativeName?: string;
  identityCard?: string;
  partyTypeEnumId?: string;
  recipientInfoStatus?: RecipientInfoStatus;
  [key: string]: any;
}

export interface SigningOrderPayload {
  signingModeEnumId?: SigningMode;
  agreementParties?: SigningOrderParty[];
}
